<template>
  <div class="dark:bg-gray-900">
    <StoreBanners />
    <StoreProductsHeading :title="$t('all_items')" />
    <StoreProducts />
  </div>
</template>

<script setup>
definePageMeta({
  layout: "store",
  scrollToTop: true,
});
</script>
